var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.25C16.0858 9.25 15.75 8.91421 15.75 8.5C15.75 8.08579 16.0858 7.75 16.5 7.75L16.5 9.25ZM8.5 7.75C8.91421 7.75 9.25 8.08579 9.25 8.5C9.25 8.91421 8.91421 9.25 8.5 9.25L8.5 7.75ZM3.25 12.5L3.25 17.5L1.75 17.5L1.75 12.5L3.25 12.5ZM6.5 20.75L18.5 20.75L18.5 22.25L6.5 22.25L6.5 20.75ZM21.75 17.5L21.75 12.5L23.25 12.5L23.25 17.5L21.75 17.5ZM18.5 9.25L16.5 9.25L16.5 7.75L18.5 7.75L18.5 9.25ZM8.5 9.25L6.5 9.25L6.5 7.75L8.5 7.75L8.5 9.25ZM21.75 12.5C21.75 10.7051 20.2949 9.25 18.5 9.25L18.5 7.75C21.1234 7.75 23.25 9.87665 23.25 12.5L21.75 12.5ZM18.5 20.75C20.2949 20.75 21.75 19.2949 21.75 17.5L23.25 17.5C23.25 20.1234 21.1234 22.25 18.5 22.25L18.5 20.75ZM3.25 17.5C3.25 19.2949 4.70508 20.75 6.5 20.75L6.5 22.25C3.87665 22.25 1.75 20.1234 1.75 17.5L3.25 17.5ZM1.75 12.5C1.75 9.87665 3.87665 7.75 6.5 7.75L6.5 9.25C4.70507 9.25 3.25 10.7051 3.25 12.5L1.75 12.5Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.5L13.2071 3.20711C12.8166 2.81658 12.1834 2.81658 11.7929 3.20711L9.5 5.5",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.5L12.5 15.5",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout-1.54f06783907d1d72ae040687c519fae3.svg";